module.exports = __webpack_public_path__ + "img/11.765b7b7c.jpg";